import { deleteQueueItem, getQueue, updateQueueItem } from './db';
import { submitReading } from './api';

export interface SyncResult { sent: number; failed: number; errors: string[] }

export async function synchronize(onProgress?: (done: number, total: number) => void): Promise<SyncResult> {
  if (!navigator.onLine) throw new Error('Keine Internetverbindung.');
  const queue = (await getQueue()).sort((a, b) => a.capturedAt.localeCompare(b.capturedAt));
  const result: SyncResult = { sent: 0, failed: 0, errors: [] };
  for (let i = 0; i < queue.length; i += 1) {
    const item = queue[i];
    try {
      await submitReading(item);
      await deleteQueueItem(item.localId);
      result.sent += 1;
    } catch (error) {
      item.attempts += 1;
      item.lastError = error instanceof Error ? error.message : String(error);
      await updateQueueItem(item);
      result.failed += 1;
      result.errors.push(`${item.meterNumber}: ${item.lastError}`);
    }
    onProgress?.(i + 1, queue.length);
  }
  return result;
}
